export const form = {
    labels: {},
    texts: {
        edit_form: "Editar Formulário",
        del_form: "Excluir Formulário",
        del_confirm: "Você deseja excluir o formulário <strong>'{concat}'</strong>?",
        del_method: "Você deseja excluir o Método <strong>'{concat}'</strong>?",
        empty_method: "Você não adicionou um Método no formulário!",
    },
};
